import { t } from 'i18next';

import { IAddressAutocomplete } from 'addresses/types';
import { IContactGroupAddress } from 'contacts/types';
import { DEFAULT_PLACEHOLDER } from 'core/constants';

import { isEmptyObject } from './object';

export const getAddressToDisplay = (
  address: IAddressAutocomplete | Partial<IContactGroupAddress>,
  options: {
    placeholder?: string;
    withAccountsReceivable?: boolean;
    displayStateName?: boolean;
    displayCountryName?: boolean;
  } = {
    placeholder: DEFAULT_PLACEHOLDER,
    withAccountsReceivable: true,
    displayStateName: false,
    displayCountryName: false,
  }
): string[] => {
  if (!address || isEmptyObject(address)) {
    return [options.placeholder];
  }

  const { line1, line2, city, state, stateName, zip, country, countryName, accountsReceivableId } =
    address;

  const stateValue = options.displayStateName ? stateName : state;
  const countryValue = options.displayCountryName ? countryName : country;

  const formatAddressParts = {
    streetAddress: [line1, line2].filter(Boolean).join(' '),
    cityState: [city, stateValue && [city ? ',' : '', stateValue].join(' ')]
      .filter(Boolean)
      .join(''),
    countryZip: [countryValue, zip].filter(Boolean).join(' '),
    accountsReceivable:
      options.withAccountsReceivable && accountsReceivableId
        ? t('labelAccountsReceivableId', { number: accountsReceivableId })
        : '',
  };

  const addressParts = Object.values(formatAddressParts).filter(Boolean);

  return addressParts.length ? addressParts : [options.placeholder];
};
